import React from 'react'
import {Layout} from 'react-admin'
import {CLBMenu} from './components/menu'
import {CustomAppBar} from './components/app-bar'
const LayoutComponent = props => (
    <Layout {...props} menu={CLBMenu} appBar={CustomAppBar}/>
)

export default LayoutComponent
